module.exports = __webpack_public_path__ + "assets/136b8d98921e4f67ca43d5c2d3345f0f.svg";